/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Sent_TitleInputs */

const en_contact_form_sent_title = /** @type {(inputs: Contact_Form_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message sent`)
};

const pl_contact_form_sent_title = /** @type {(inputs: Contact_Form_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiadomość wysłana`)
};

/**
* | output |
* | --- |
* | "Message sent" |
*
* @param {Contact_Form_Sent_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_sent_title = /** @type {((inputs?: Contact_Form_Sent_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Sent_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_sent_title(inputs)
	return en_contact_form_sent_title(inputs)
});